// helper.js
import { filterAssistantData } from "../../util";

export function updateDashboardState(prevState, results, assistantList) {
  const newState = { ...prevState };

  results.forEach(({ key, data, error }) => {
    newState[key] = buildEntryState(key, data, error, assistantList);
  });

  return newState;
}

function buildEntryState(key, data, error, assistantList) {
  if (error) {
    return { loading: false, data: {}, error: error.message };
  }

  const isFCR = key === 'firstCallResolution' && Array.isArray(data);
  const isAvg = key === 'averageCallPerAssistant'
    && data?.assistants?.length > 0;
  const needsFilter = assistantList.length > 0 && (isFCR || isAvg);

  if (!needsFilter) {
    return { loading: false, data, error: null };
  }

  // pick the right array to filter
  const source = isFCR ? data : data.assistants;
  const filtered = filterAssistantData(assistantList, source);

  // rebuild payload
  const newData = isFCR
    ? filtered
    : { ...data, assistants: filtered };

  return { loading: false, data: newData, error: null };
}
